import React from 'react';

interface TestStatusItemProps {
  label: string;
  value: string | number;
  color?: 'default' | 'green' | 'red';
}

export const TestStatusItem: React.FC<TestStatusItemProps> = ({
  label,
  value,
  color = 'default',
}) => {
  const colorClasses = {
    default: 'font-medium',
    green: 'font-medium text-green-600',
    red: 'font-medium text-red-600',
  };

  return (
    <div className="flex justify-between text-sm">
      <span>{label}</span>
      <span className={colorClasses[color]}>{value}</span>
    </div>
  );
};
